var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBearError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159.512,
    height: 160.559,
    viewBox: "0 0 159.512 160.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#d9d9d9;}.b,.d,.e{fill:#fff;}.c{fill:#fc0;}.d,.e,.f{stroke:#d9d9d9;stroke-miterlimit:10;}.d{stroke-width:1.6px;}.g{fill:none;}.h{fill:#6a148e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1193.169 -566.704)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1037.909,668.267c-8.693,32.7-33.377,58.83-85.064,59-64.347.206-69.553-45.069-70.19-88.939-.735-50.654,72.663-66.568,112.62-71.322C-1036.975,561.818-1026.567,625.6-1037.909,668.267Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1179.933 602.801)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1142.516,704.544a10.525,10.525,0,0,1-3.651-.656c-.945-.349-23.183-8.854-25.8-34.885a10.537,10.537,0,0,1,9.431-11.538A10.537,10.537,0,0,1-1151,666.9a21.024,21.024,0,0,0,12.134,17.224,10.537,10.537,0,0,1,6.232,13.536A10.543,10.543,0,0,1-1142.516,704.544Z",
    transform: "translate(1173.64 -629.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1151.878,711.533l9.245,7.193c5.964,4.629,14.232,3.955,18.461-1.5l1.279-1.644c4.215-5.458,2.81-13.635-3.133-18.265l-9.245-7.193Z",
    transform: "translate(1167.648 -639.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1151.878,711.533l9.245,7.193c5.964,4.629,14.232,3.955,18.461-1.5l1.279-1.644c4.215-5.458,2.81-13.635-3.133-18.265l-9.245-7.193Z",
    transform: "translate(1167.648 -639.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1153.316,628.452a10.538,10.538,0,0,0-6.365-10.291,1.089,1.089,0,0,0-1.4.631,1.081,1.081,0,0,0,0,.774l1.5,3.723a3.337,3.337,0,0,1-1.825,4.352l-.008,0-4.088,1.672a3.336,3.336,0,0,1-4.353-1.821l0-.006-1.581-3.864a1.082,1.082,0,0,0-1.411-.591,1.083,1.083,0,0,0-.591.591,10.537,10.537,0,0,0,4.264,13.256l-1.932,32.75a5.185,5.185,0,0,0,4.864,5.486h.011a5.183,5.183,0,0,0,5.479-4.871v0l1.96-33.15A10.538,10.538,0,0,0-1153.316,628.452Z",
    transform: "translate(1174.327 -618.089)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1048.814,758.766c-1.775-30.357-21.6-28.236-45.784-28.236-25.353,0-48.725,0-45.915,32.862a26.584,26.584,0,0,0,1.907,7.9c8.442,3.057,18.713,4.745,31.23,4.7C-1081.589,775.911-1062.526,769.365-1048.814,758.766Z",
    transform: "translate(-15.598 -48.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1127.212,710.2a78.664,78.664,0,0,0-17.849,24.916,2.814,2.814,0,0,0,1.653,3.772c10.629,3.763,50.411,15.588,94.381.08a2.824,2.824,0,0,0,1.55-4c-3.609-6.678-12.881-22.953-19.476-26.775C-1066.981,708.166-1096.373,688.834-1127.212,710.2Z",
    transform: "translate(-14.243 -39.701)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1157.679 582.285)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.537 7.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 15.103,
    cy: 15.103,
    r: 15.103
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1112.608,621.712a40.449,40.449,0,0,1,15.268-7.893,9.068,9.068,0,0,0-10.338-7.591,9.069,9.069,0,0,0-7.591,10.338A9.066,9.066,0,0,0-1112.608,621.712Z",
    transform: "translate(1120.997 -601.073)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.742 13.46)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 15.103,
    cy: 15.103,
    r: 15.103
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1021.528,644.492a9.1,9.1,0,0,0,3.964-12.23,9.07,9.07,0,0,0-12.2-3.984,9.06,9.06,0,0,0-1.848,1.252A41.284,41.284,0,0,1-1021.528,644.492Z",
    transform: "translate(1040.336 -620.83)"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 39.311,
    cy: 41.482,
    rx: 39.311,
    ry: 41.482,
    transform: "translate(0 86.2) rotate(-76.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1042.683,656.563a10.522,10.522,0,0,1-6.742-2.242,8.991,8.991,0,0,1-2.419-2.9.7.7,0,0,1,.341-.933.7.7,0,0,1,.932.339c.1.213,2.475,5.043,9.368,4.243a.7.7,0,0,1,.779.617.7.7,0,0,1-.617.778A14.239,14.239,0,0,1-1042.683,656.563Z",
    transform: "translate(1115.652 -607.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1100.862,650.141a.7.7,0,0,1-.32-.077.7.7,0,0,1-.3-.945,10.927,10.927,0,0,1,6.443-5.777,8.989,8.989,0,0,1,3.756-.4.7.7,0,0,1,.586.8.7.7,0,0,1-.8.587c-.237-.036-5.569-.745-8.735,5.428A.7.7,0,0,1-1100.862,650.141Z",
    transform: "translate(1130.425 -604.952)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.509 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1050.162,618.214c-2.544,10.537-3.47,21.79-24.242,16.773-21.387-5.164-16.454-15.449-13.909-25.986s5.733-19.884,23.624-15.563C-1046.6,597.806-1047.62,607.684-1050.162,618.214Z",
    transform: "translate(1090.677 -589.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-1086.921,613.45a34.009,34.009,0,0,0,38.2,8.92",
    transform: "translate(1089.56 -596.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M-1087.312,613.543a29.3,29.3,0,0,0,6.5,5.652,33.9,33.9,0,0,0,17.673,5.85,37.431,37.431,0,0,0,14.384-2.5c.422-.159.2-.833-.2-.67a34.794,34.794,0,0,1-23.318.794,34.737,34.737,0,0,1-12.618-7.6,21.73,21.73,0,0,1-1.964-2.042c-.284-.351-.762.163-.483.505Z",
    transform: "translate(1089.709 -596.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1066.577,589l13.541,3.27a3.02,3.02,0,0,1,2.227,3.645h0l-5.167,21.4a3.021,3.021,0,0,1-3.645,2.228h0l-14.7-3.55a3.02,3.02,0,0,1-2.227-3.645h0l4.887-20.24A4.215,4.215,0,0,1-1066.577,589Z",
    transform: "translate(1086.5 -588.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1066.577,589l13.541,3.27a3.02,3.02,0,0,1,2.227,3.645h0l-5.167,21.4a3.021,3.021,0,0,1-3.645,2.228h0l-14.7-3.55a3.02,3.02,0,0,1-2.227-3.645h0l4.887-20.24A4.215,4.215,0,0,1-1066.577,589Z",
    transform: "translate(1086.5 -588.884)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "g",
    y1: 20.895,
    x2: 5.046,
    transform: "translate(9.949 2.571)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "g",
    y1: 21.032,
    x2: 5.079,
    transform: "translate(30.523 7.403)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 8.985,
    cy: 8.985,
    r: 8.985,
    transform: "translate(13.243 8.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-1063.666,607.055l.171.041c.191.046.518.126.968.27l.642.155.635.154c1.966.475,2.952,1.572,2.6,2.955a2.587,2.587,0,0,1-1.988,1.767l-.109.032h0a10.645,10.645,0,0,0,1.132,2.586,3.514,3.514,0,0,0,1.458,1.414.226.226,0,0,1,.136.243.183.183,0,0,1-.1.157c-.095.064-.255.068-.787-.06-1.83-.442-2.379-2.121-2.779-3.453-.058-.151-.095-.3-.147-.44h0a1.068,1.068,0,0,0-.47-.6l-.068-.016a.338.338,0,0,1-.2-.374.239.239,0,0,1,.286-.179.265.265,0,0,1,.036.011l.089.022a2.183,2.183,0,0,0,.328.079,1.713,1.713,0,0,0,1.321-.172,1.561,1.561,0,0,0,.732-.994,1.967,1.967,0,0,0-1.728-2.361c-.43-.1-.457-.111-.5.067l-1.3,5.394c-.221.915.186,1.086.5,1.219.178.043.4.162.344.4s-.4.185-.542.151l-.438-.106a7.849,7.849,0,0,0-.82-.285l-.745-.18-.471-.114a.316.316,0,0,1-.262-.352c.048-.2.252-.207.405-.213s.554.011.719-.672l1.235-5.114c.165-.683-.086-.78-.33-.846s-.4-.1-.337-.4a.266.266,0,0,1,.312-.212A.252.252,0,0,1-1063.666,607.055Z",
    transform: "translate(1083.258 -594.282)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.943 45.418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1092.349,708.717a21.212,21.212,0,0,1-15.622-25.568,21.211,21.211,0,0,1,25.568-15.622,21.21,21.21,0,0,1,15.622,25.568A21.211,21.211,0,0,1-1092.349,708.717Z",
    transform: "translate(1108.565 -657.522)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 7.833,
    cy: 7.833,
    r: 7.833,
    transform: "translate(14.481 18.11)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.642)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.295,
    cy: 3.295,
    r: 3.295
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.295,
    cy: 3.295,
    r: 3.295,
    transform: "translate(26.103 6.585)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1085.151,708.7a9.674,9.674,0,0,1,6.8,6.029.7.7,0,0,1-.413.9.7.7,0,0,1-.9-.412,8.27,8.27,0,0,0-5.811-5.155,8.29,8.29,0,0,0-7.394,1.821.7.7,0,0,1-.991-.065.7.7,0,0,1,.065-.992A9.7,9.7,0,0,1-1085.151,708.7Z",
    transform: "translate(1104.244 -669.87)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1082.651 621.936)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1023.323,649.472a10.533,10.533,0,0,0-1.314,10.537,20.707,20.707,0,0,1-2.408,21.025l.089-.106,15.941,13.784c.659-.761,16.029-18.949,5.758-42.985a10.538,10.538,0,0,0-13.831-5.549A10.49,10.49,0,0,0-1023.323,649.472Z",
    transform: "translate(1033.226 -645.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1005.8,700.326l-4.3,10.28c-2.766,6.642-10.094,9.767-16.405,6.945l-1.895-.84c-6.293-2.8-9.149-10.454-6.394-17.105l4.3-10.28Z",
    transform: "translate(1035.844 -658.418)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1076.32,613.361l5.052-20.923a.351.351,0,0,0-.259-.424.351.351,0,0,0-.424.259l-5.046,20.9a.351.351,0,0,0,.259.424.351.351,0,0,0,.424-.259Z",
    transform: "translate(-34.561 -7.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1047.015,620.392l5.078-21.032a.351.351,0,0,0-.259-.424.352.352,0,0,0-.424.259l-5.079,21.032a.352.352,0,0,0,.259.424A.351.351,0,0,0-1047.015,620.392Z",
    transform: "translate(-43.277 -9.587)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearError);
export default __webpack_public_path__ + "static/media/bearError.6ec6cef6c766812c5f14f80760bb4530.svg";
export { ForwardRef as ReactComponent };